import React from 'react'

import {serialPattern} from "../_utils/item/serial";

import './EditItemMeta.sass'

export const EditItemMeta = ({ errors, register }) => {
  return <div className='section edit-item-meta'>
    <div className="form-group">
      <label>Model</label>
      <input name="model" className="form-control" ref={register({
        required: "Model is a required field."
      })}/>
      {errors.model && <small><p>{errors.model.message}</p></small>}
    </div>
    <div className="form-group">
      <label>Serial number</label>
      <input name="serialNumber" className="form-control" ref={register({
        required: "Serial number is a required field.",
        pattern: {
          value: serialPattern,
          message: "A serial number may only consist of uppercase letters, digits, hyphens, spaces, slashes, and dots."
        }
      })}/>
      {errors.serialNumber && <small><p>{errors.serialNumber.message}</p></small>}
    </div>
    <div className="form-group">
      <label>Date of manufacture</label>
      <input name="productionDate" type="date" className="form-control date" ref={register({
        required: "Date of manufacture is a required field."
      })}/>
      {errors.productionDate && <small><p>{errors.productionDate.message}</p></small>}
    </div>
    <div className="form-check">
      <input className="form-check-input" name="isFeatured" type="checkbox" id="isFeaturedCheck" ref={register()} />
      <label className="form-check-label" htmlFor="isFeaturedCheck">Featured</label>
      {/* TODO: add a question mark icon with a tooltip? */}
    </div>
  </div>
}
